const Builder = require('./BuilderBase');
const DatePicker = require('./formElements/DatePicker');
const DropDown = require('./formElements/DropDown');
const EditableList = require('./formElements/EditableList');
const ElementGroups = require('./formElements/ElementGroups');
const FormButton = require('./FormButton/FormButton');
const MenuButton = require('./FormButton/MenuButton');
const HiddenFor = require('./HiddenFor');
const InvisibleElement = require('./InvisibleElement');
const ShortText = require('./formElements/ShortText');
const Toggle = require('./formElements/Toggle');
const NestedObject = require('./formElements/NestedObject');
const WorkflowActionList = require('./WorkflowActionList');
const WorkflowCriteriaPane = require('./WorkflowCriteriaPane');
const MultiPickerSensorGrid = require('./formElements/MultiPickerSensorGrid');
const MultiPickerShortText = require('./formElements/MultiPickerShortText');
const TabViewLayout = require('./layouts/TabViewLayout');
const TextLabel = require('./formElements/TextLabel');
const PageAccess = require('./formElements/PageAccess');

module.exports = class Form extends Builder {
    constructor(title, properties) {
        super('form_Form', title, properties);
    }

    datePicker(title, properties) {
        const datePicker = new DatePicker(title, properties);
        this.addChildBlock(datePicker);
        return datePicker;
    }

    toggle(title, properties) {
        let toggle = new Toggle(title, properties);
        this.addChildBlock(toggle);
        return toggle;
    }

    shortText(title, properties) {
        let shortText = new ShortText(title, properties);
        this.addChildBlock(shortText);
        return shortText;
    }

    dropDown(title, properties) {
        let dropDown = new DropDown(title, properties);
        this.addChildBlock(dropDown);
        return dropDown;
    }

    formButton(title, properties) {
        let button = new FormButton(title, properties);
        this.addChildBlock(button, 'formButtons');
        return button;
    }
    menuButton(title, properties) {
        let button = new MenuButton(title, properties);
        this.addChildBlock(button, 'formButtons');
        return button;
    }

    editableList(title, properties) {
        let editableList = new EditableList(title, properties);
        this.addChildBlock(editableList);
        return editableList;
    }

    elementGroups(title, properties) {
        let block = new ElementGroups(title, properties);
        this.addChildBlock(block);
        return block;
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    invisibleElement(title, properties) {
        let element = new InvisibleElement(title, properties);
        this.addChildBlock(element);
        return element;
    }

    image(title, properties) {
        const image = new Builder.blockTypes['Image'](title, properties);
        this.addChildBlock(image);
        return image;
    }

    layout(options) {
        // requiring this inline avoids problems with looping dependencies.
        let layout = new (require('./Layout'))('testLayout');
        this.addChildBlock(layout, undefined, options);
        return layout;
    }

    MultiPickerSensorGrid(title, properties) {
        const picker = new MultiPickerSensorGrid(title, properties);
        this.addChildBlock(picker);
        return picker;
    }

    MultiPickerShortText(title, properties) {
        const picker = new MultiPickerShortText(title, properties);
        this.addChildBlock(picker);
        return picker;
    }

    subForm(title, properties) {
        const _layout = this.layout();
        // requiring this inline avoids problems with looping dependencies.
        const subForm = new (require('./SubForm'))(title, properties);
        _layout.addChildBlock(subForm);
        return subForm;
    }

    workflowCriteriaPane() {
        let criteriaPane = new WorkflowCriteriaPane();
        this.addChildBlock(criteriaPane);
        return criteriaPane;
    }

    workflowActionList(title) {
        let actionList = new WorkflowActionList(title);
        this.addChildBlock(actionList);
        return actionList;
    }

    tabViewLayout(title) {
        const tabViewLayout = new TabViewLayout(title);
        this.addChildBlock(tabViewLayout);
        return tabViewLayout;
    }

    nestedObject(title, properties) {
        let nestedObject = new NestedObject(title, properties);
        this.addChildBlock(nestedObject);
        return nestedObject;
    }

    textLabel(title, properties) {
        let element = new TextLabel(title, properties);
        this.addChildBlock(element);
        return element;
    }

    pageAccess(title, properties) {
        let element = new PageAccess(title, properties);
        this.addChildBlock(element);
        return element;
    }
};
